import { render, staticRenderFns } from "./CookieAlert.vue?vue&type=template&id=1324f598&scoped=true&"
import script from "./CookieAlert.vue?vue&type=script&lang=ts&"
export * from "./CookieAlert.vue?vue&type=script&lang=ts&"
import style0 from "./CookieAlert.vue?vue&type=style&index=0&id=1324f598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1324f598",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
